
export const PATHS = {
  ROOT: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  // Public by requirement: Play mandates a web deletion path usable without the app.
  DELETE_ACCOUNT: "/delete-account",
  INFO: "/info",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS: "/terms",
  SUPPORT: "/support",
  // Public: the self-serve install guide. Short URL, read aloud from the front, printed on QR cards.
  GET_THE_APP: "/app",
  GET_THE_APP_CODE: "/app/:code",
  ANDROID: "/android",
  ANDROID_CODE: "/android/:code",
  IOS: "/ios",
  IOS_CODE: "/ios/:code",
  // Public, unlisted: password-gated install-funnel dashboard.
  FUNNEL: "/funnel",
  ORGANISATIONS: "/organisations",
  OVERVIEW: "/overview",
  TAGS: "/tags",
  CLASSES: "/classes",
  CLASS: "/classes/:id",
  CLASS_RECORDS: "/classes/:id/records",
  ALL_RECORDS: "/classes/records",
  CLASS_CREATE: "/classes/create",
  PEOPLE: "/people",
  BIRTHDAYS: "/birthdays",
  PERSON: "/people/:id",
  PERSON_RECORDS: "/people/:id/records",
  PEOPLE_CREATE: "/people/create",
  ONBOARDING: "/onboarding",
  ADMIN_TOOLS: "/admin",
  DASHBOARD: "/dashboard",
  ATTENDANCE: "/attendance",
  BLOCK_ATTENDANCE: "/block-attendance",
  ATTENDANCE_COMPARE: "/attendance-compare",
  LOGOUT: "/logout",

  POSTS: "/posts",
  POSTS_CREATE: "/posts/compose",
  POST_REVIEWS: "/posts/reviews",
  POST_REVIEW: "/posts/reviews/:postId",
  POSTS_ENGAGEMENT: "/posts/engagement",
  POSTS_SCHEDULED: "/posts/scheduled",
  POST_SCHEDULED: "/posts/scheduled/:postId",
  POST_SENT: "/posts/sent/:postId",
  GALLERY: "/gallery",
  TAG_IMAGE: "/gallery/:imageId/tags",
  ADMIN_SETTINGS: "/admin/settings",

  LEADERSHIP: "/leadership",
  PARTNERSHIPS: "/partnerships",
  COURSE_DELIVERY_AUDIT: "/course-delivery-audit",

  // old - just here for redirection
  COURSES: "/courses",
  COURSE: "/courses/:id",
}
